import { Link, platformContext, PoweredBy } from "shared";
import React, { PropsWithChildren, useContext, useMemo } from "react";
import cn from 'classnames';
import { Platform } from "@yandex-int/hr-components/lib";
import { useTranslation } from "react-i18next";
import { usePageLayoutTranslations } from "../../lib/i18n";
import styles from './page-footer.module.scss';
import { useLocation } from "react-router-dom";

export const PageFooter: React.FC<
    PropsWithChildren & { className?: string, isExternal: boolean }
> = ({ className, children, isExternal }) => {
    const { i18n } = useTranslation();
    const location = useLocation();
    const platform = useContext(platformContext);
    const t = usePageLayoutTranslations();
    const isIframe = useMemo(() => {
        const path = location.pathname.split("/");
        return path[1] === "iframe";
    }, [location.pathname]);

    if (isIframe || isExternal) {
        return null;
    }

    return platform === Platform.DESKTOP ?
        <div className={cn(styles.footer, className, styles.footerDesktop)}>
            {!isExternal &&<div className={styles.footerLinks}>
                <PoweredBy/>
            </div>}
            {children}
            {!isExternal && <div className={styles.footerRightGroup}>
                <Link
                    className={cn(styles.confidentialLink, styles.confidentialDesktop)}
                    text={t('confidential')}
                    url={`https://yandex.ru/legal/confidential/?lang=${i18n.language}`}
                />
                <div>
                    {t('yandex')}
                </div>
            </div>}
        </div> :
        <div className={cn(styles.footer, className, styles.footerMobile)}>
                {!isExternal &&<div className={styles.footerLinksMobile}>
                    <PoweredBy/>
                </div>}
                {children}
                {!isExternal && <div className={styles.footerRightGroupMobile}>
                    <Link
                        className={styles.confidentialLink}
                        text={t('confidential')}
                        url={`https://yandex.ru/legal/confidential/?lang=${i18n.language}`}
                    />
                    <span>
                        {t('yandexShort')}
                    </span>
                </div>}

        </div>
};
